import React, { useEffect } from "react";
import CareerCard from "../components/CareerCard";

const jobs = [
  // {
  //   title: "Female Football Coaches ⚽",
  //   subtitle: "Join our team and be a part of creating change through sport!",
  //   description:
  //     "We are looking for female football coaches who are passionate about coaching and community impact.",
  //   locations: ["Nagpur", "Pune", "Chennai", "Delhi", "Mumbai"],
  //   requirements: [
  //     "Minimum 2 years of coaching experience (Freshers need not apply)",
  //     "D License or equivalent coaching experience",
  //     "Ability to manage participants, conduct tournaments & workshops, and complete reporting",
  //   ],
  //   jobType: "Full-time Position",
  //   salary: "Salary based on experience and discussion",
  //   callToAction: {
  //     title: "Ready to lead from the front and make a difference?",
  //     subtitle: "Get in touch with us today",
  //     email: "mahima.b@slumsoccer.org",
  //   },
  // },
  // {
  //   title: "Project Coordinators",
  //   subtitle:
  //     "Are you passionate about driving change through sports and education?",
  //   description:
  //     "We're looking for Project Coordinators who can independently manage and lead community-based programs.",
  //   locations: ["Delhi", "Goa"],
  //   requirements: [
  //     "Minimum 5 years of experience, preferably in the sports or development sector",
  //     "Strong skills in supervising sessions, conducting trainings, creating reports, and submitting timely documentation",
  //     "Ability to gather stakeholder feedback, work with schools and communities",
  //     "Must be willing to travel as part of the role",
  //     "Should be confident in managing programs independently",
  //   ],
  //   jobType: "Full-time Position",
  //   salary: "Salary based on experience and discussion",
  //   callToAction: {
  //     title: "Ready to take on a leadership role and create meaningful impact?",
  //     subtitle: "Get in touch with us today",
  //     email: "mahima.b@slumsoccer.org",
  //   },
  // },
  // {
  //   title: "Sports Coaches (Volleyball, Kabaddi, Kho-Kho, Football, Athletics)",
  //   subtitle:
  //     "Are you passionate about coaching and shaping young talent through sports?",
  //   description:
  //     "We are looking for experienced coaches in the following sports: 🏐 Volleyball | 🤼 Kabaddi | 🏃 Kho-Kho | ⚽ Football | 🏃‍♂️ Athletics",
  //   locations: ["Nagpur", "Delhi", "Pune", "Goa", "Mumbai", "Chennai"],
  //   requirements: [
  //     "2–3 years of coaching experience in schools, clubs, or similar settings.",
  //     "Thorough knowledge of the game",
  //     "State or National-level representation is preferred",
  //     "Commitment to conduct and report sessions regularly",
  //   ],
  //   jobType: "Full-time Position",
  //   salary: "Salary based on experience and discussion",
  //   callToAction: {
  //     title:
  //       "Join us and be a part of a movement that uses sport for social change!",
  //     subtitle: "Get in touch with us today",
  //     email: "mahima.b@slumsoccer.org",
  //   },
  // },
];

export default function Career(props) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="py-16 bg-gradient-to-b from-gray-50 to-gray-100 animate__animated animate__bounceInUp">
      <div className="container mx-auto px-9">
        <div className="text-center mb-5">
          <h2 className="text-4xl font-bold text-orange-500 relative inline-block -mt-5">
            Career at Slum Soccer
            <div className="h-1 w-full bg-orange-500 mt-2"></div>
          </h2>
        </div>

        {/* {jobs.length === 0 ? (
          <div className="text-center py-16">
            <div className=" mx-auto bg-white rounded-lg shadow-md p-8">
              <svg
                className="w-16 h-16 mx-auto mb-4 text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>
              <h3 className="text-2xl font-semibold text-gray-800 mb-3">
                No Current Openings
              </h3>
              <p className="text-gray-600 mb-4">
                We don't have any open positions at the moment, but we're always looking for talented individuals who are passionate about creating change through sports.
              </p>
              <p className="text-gray-600">
                Please check back later or reach out to us at{" "}
                <a
                  href="mailto:mahima.b@slumsoccer.org"
                  className="text-orange-500 hover:text-orange-600 font-medium"
                >
                  mahima.b@slumsoccer.org
                </a>
              </p>
            </div>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {jobs.map((job, index) => (
              <CareerCard
                key={index}
                title={job.title}
                subtitle={job.subtitle}
                description={job.description}
                locations={job.locations}
                requirements={job.requirements}
                jobType={job.jobType}
                salary={job.salary}
                callToAction={job.callToAction}
              />
            ))}
          </div>
        )} */}

        <div className="text-center py-16">
            <div className=" mx-auto bg-white rounded-lg shadow-md p-8">
              <svg
                className="w-16 h-16 mx-auto mb-4 text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>
              <h3 className="text-2xl font-semibold text-gray-800 mb-3">
                No Current Openings
              </h3>
              <p className="text-gray-600 mb-4">
                We don't have any open positions at the moment, but we're always looking for talented individuals who are passionate about creating change through sports.
              </p>
              <p className="text-gray-600">
                Please check back later or reach out to us at{" "}
                <a
                  href="mailto:mahima.b@slumsoccer.org"
                  className="text-orange-500 hover:text-orange-600 font-medium"
                >
                  mahima.b@slumsoccer.org
                </a>
              </p>
            </div>
          </div>
      </div>
    </section>
  );
}